import { BaseService } from '@zaoblako/web/core/services/base.service';
import type { Connection1cCredentialsInterface } from '@zaoblako/shared/modules/integration/dtos/connection-1c/connection-1c-credentials.dto';
import type { Connection1cCredentialsTestResultInterface } from '@zaoblako/shared/modules/integration/dtos/connection-1c/connection-1c-credentials-test-result.dto';
import type { Connection1cConsoleFormInterface } from '@zaoblako/shared/modules/integration/dtos/connection-1c-console/connection-1c-console-form.dto';
import type { Connection1cConsoleResultInterface } from '@zaoblako/shared/modules/integration/dtos/connection-1c-console/connection-1c-console-result.dto';

import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class Integration1cService extends BaseService {
  protected baseUrl = '/integration/1c/connection';

  public testConnection(database: Connection1cCredentialsInterface): Observable<Connection1cCredentialsTestResultInterface> {
    return this.http.post<Connection1cCredentialsTestResultInterface>(`${this.baseUrl}/test`, database);
  }

  public testConsoleExecute(id: number, body: Connection1cConsoleFormInterface): Observable<Connection1cConsoleResultInterface> {
    return this.http.post<Connection1cConsoleResultInterface>(`${this.baseUrl}/${id}/test-console`, body);
  }
}
